import { TableColumns } from "../../../../core/models/dashboard/tableColumns";

export const columns: TableColumns[] = [
  {
    header: "Invoice",

    field: "invoice",

    link: true,

    linkField: "invoice",

    isDate: false,

    isNumber: false,
  },

  {
    header: "Sales Order",

    field: "salesOrder",

    link: true,

    linkField: "salesOrder",

    isDate: false,

    isNumber: false,
  },

  {
    header: "Client Name",

    field: "clientD365",

    link: true,

    linkField: "customerAccount",

    isDate: false,

    isNumber: false,
  },

  {
    header: "Due Date",

    field: "dueDate",

    link: false,

    linkField: "",

    isDate: true,

    isNumber: false,
  },

  {
    header: "Outstanding $",

    field: "openAmountUSD",

    link: false,

    linkField: "",

    isDate: false,

    isNumber: false,
  },

  {
    header: "Days Past Due",

    field: "daysPastDate",

    link: false,

    linkField: "",

    isDate: false,

    isNumber: false,
  },

  {
    header: "AR Notes",

    field: "note",

    link: false,

    linkField: "",

    isDate: false,

    isNumber: false,
  },
];
